import classes from "../styles/contact.module.css";
import emailjs from "emailjs-com";
import { Form } from "react-router-dom";
import gmail from "../assets/images/gmail.png";

import linkedin from "../assets/images/linkedin.png";
import phone from "../assets/images/telephone.png";

export default function ContactPage() {
  const handleContactFormSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const name = formData.get("name");
    const email = formData.get("email");
    const subject = formData.get("subject");
    const message = formData.get("message");

    // Log form data (Optional)

    console.log("Form Data", { name, email, subject, message });

    // Sending mail using EmailJS (example)
    const serviceId = "service_59f31y5";
    const templateId = "template_s1p5wzp";
    const userId = "dPiGyWTpmfYelaMNF";

    const emailData = {
      from_name: name,
      from_email: email,
      subject: subject,
      message: message,
    };

    emailjs
      .send(serviceId, templateId, emailData, userId)
      .then((response) => {
        console.log("SUCCESS!", response.status, response.text);
        alert("Message sent successfully! you will be contacted soon.");
      })
      .catch((error) => {
        console.error("FAILED...", error);
        alert("Failed to send message. Please try again later.");
      });
  };

  return (
    <div className={classes["contact-page"]}>
      <div className={classes["contact-page-content"]}>
        <span>"Have a project in mind? Reach out!"</span>
        <div className={classes["contact-boxes"]}>
          <div className={classes.box}>
            <a
              href="mailto:srajalakshmi62@gmail.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={gmail} alt="GmailLogo" />
            </a>
          </div>
          <div className={classes.box}>
            <a
              href="https://www.linkedin.com/in/rajalakshmi-sudhakar"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={linkedin} alt="LinkedinLogo" />
            </a>
          </div>
          <div className={classes.box}>
            <a
              href="tel:+16177087960"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={phone} alt="PhoneLogo" />
            </a>
          </div>
        </div>

        {/*-------contact form----------*/}

        <div className={classes["contact-form-container"]}>
          <h2>Contact Form</h2>
          <Form
            className={classes["contact-form"]}
            onSubmit={handleContactFormSubmit}
          >
            <div className={classes["form-group"]}>
              <label htmlFor="name">Name:</label>
              <input
                type="text"
                id="name"
                name="name"
                placeholder="Enter your name"
                required
              />
            </div>
            <div className={classes["form-group"]}>
              <label htmlFor="email">Email:</label>
              <input
                type="email"
                id="email"
                name="email"
                placeholder="Enter your email"
                required
              />
            </div>
            <div className={classes["form-group"]}>
              <label htmlFor="subject">Subject:</label>
              <input
                type="text"
                id="subject"
                name="subject"
                placeholder="Enter the subject"
              />
            </div>
            <div className={classes["form-group"]}>
              <label htmlFor="message">Message:</label>
              <textarea
                id="message"
                name="message"
                rows="5"
                placeholder="Enter your message"
                required
              ></textarea>
            </div>
            <button type="submit">Submit</button>
          </Form>
        </div>
      </div>
    </div>
  );
}
